import { AppRegistry, StyleSheet, View, Image, Text, TouchableOpacity, Linking, Platform, Modal, ScrollView } from 'react-native';    //importing the text and view from react-native
import { createDrawerNavigator, DrawerContentScrollView, DrawerItemList } from '@react-navigation/drawer';
import { NavigationContainer } from '@react-navigation/native'; //importing the navigation container from react-navigation
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import HTML from 'react-native-render-html';
import { LogBox } from 'react-native';
import { FontAwesome5 } from '@expo/vector-icons';
import { useState } from 'react';
import React from 'react';
import { Provider, useSelector } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './redux/store';
import HomeScreen from './screens/Home';
import ProfileScreen from './screens/Profile';
import RuleDetailsScreen from './screens/RuleDetailsScreen';


const Drawer = createDrawerNavigator();
const Stack = createNativeStackNavigator();

let termsOfService = `
  <p>  Last Modified: March 17, 2024 </p>
    
  <h2> Acceptance of the Terms of Use </h2>
    
  <p> These terms of use ("<strong>Terms of Use</strong>") are a legally binding agreement between you ("<strong>User</strong>," "<strong>you</strong>," or "<strong>your</strong>") and Swift Coders ("<strong>Company</strong>," "<strong>we</strong>," "<strong>us</strong>," or "<strong>our</strong>"). These Terms govern your access to and use of the Rules of Pickleball website <strong>https://pbrulebook.com</strong>, including any content, features, and services offered on or through <strong>https://pbrulebook.com</strong> (the"Website"). By accessing or using the website, you agree to be bound by these Terms. If you do not agree with all of these Terms, you must not access or use the Website. </p>
    
  <h2> Age Requirement </h2>
    
  <p> The Website is intended for individuals who are 13 years of age or older. By accessing or using the Website, you represent and warrant that you are at least 13 years old and have the legal capacity to enter into these Terms. If you are under 13 years old, you may not access or use the Website. </p>
    
  <h2> Changes to the Terms of Use </h2>
    
  <p> We reserve the right to modify or replace these Terms at any time. The date of the last revision will be updated accordingly. It is your responsibility to review these Terms periodically for changes. Your continued use of the Website after any revisions to these Terms constitutes acceptance of those changes. </p>
    
  <h2> Accessing the Website and Account Security </h2>
    
  <p> We reserve the right to withdraw or amend the Website, and any service or material we provide on the Website, in our sole discretion without notice. We will not be liable if for any reason all or any part of the Website is unavailable at any time or for any period. From time to time, we may restrict access to some parts of the Website, or the entire Website, to users, including registered users. </p>
    
  <p> You are responsible for ensuring that all persons who access the Website through your internet connection are aware of these Terms and comply with them. If you choose, or are provided with, a username, password, or any other piece of information as part of our security procedures, you must treat such information as confidential. You must not disclose it to any third party. We have the right to disable any username, password, or other identifier, whether chosen by you or provided by us, at any time if, in our opinion, you have violated any provision of these Terms. </p>
    
  <h2> Intellectual Property Rights </h2>
    
  <p> The Website and its entire contents, features, and functionality are owned by Swift Coders or its licensors and are protected by copyright, trademark, and other laws. These Terms permit you to use the Website for your personal, non-commercial use only. You must not reproduce, distribute, modify, create derivative works of, publicly display, publicly perform, republish, download, store, or transmit any of the material on our Website, except as expressly permitted. </p>
    
  <h2> Prohibited Uses </h2>
    
  <p> You agree not to use the Website: </p>
  <ul>  
  <li> In any way that violates any applicable federal, state, local, or international law or regulation. </li>
  <li> To impersonate or attempt to impersonate Swift Coders, a Company employee, another user, or any other person or entity. </li>
  <li> To engage in any other conduct that restricts or inhibits anyone's use or enjoyment of the Website. </li>
  </ul>

  <h2> User Contributions </h2>
    
  <p> The Website may contain interactive features that allow users to post, submit, publish, display, or transmit content or materials on or through the Website ("User Contributions"). All User Contributions must comply with the content standards set out in these Terms. </p>
    
  <p> By providing any User Contributions, you grant us and our affiliates a perpetual, irrevocable, worldwide, royalty-free, sublicensable, and transferable license to use, reproduce, distribute, modify, adapt, publicly perform, publicly display, transmit, stream, broadcast, and otherwise exploit such User Contributions. </p>
    
  <h2> Monitoring and Enforcement; Termination </h2>
    
  <p> We have the right to: </p>
  <ul>  
  <li> Remove or refuse to post any User Contributions for any reason in our sole discretion. </li>
  <li> Take appropriate legal action, including referral to law enforcement, for any illegal or unauthorized use of the Website. </li>
  </ul>

  <h2> Disclaimer of Warranties </h2>
    
  <p> The Website and its content are provided on an "as is" and "as available" basis, without any warranties of any kind. </p>
    
  <h2> Limitation of Liability </h2>
    
  <p> In no event will Swift Coders, its affiliates, or their licensors, service providers, employees, agents, officers, or directors be liable for damages of any kind. </p>
    
  <h2> Indemnification </h2>
    
  <p> You agree to indemnify, defend, and hold harmless Swift Coders and its affiliates, licensors, and service providers from any claims, liabilities, damages, judgments, awards, losses, costs, expenses, or fees arising out of or relating to your violation of these Terms. </p>
    
  <h2> Governing Law and Jurisdiction </h2>
    
  <p> These Terms and any dispute or claim arising out of or related to them or the Website will be governed by and construed in accordance with the laws of Canada, without regard to its conflict of law provisions. </p>
    
  <h2> Contact Us </h2>
    
  <p> If you have any questions about these Terms, please contact us at <strong>support@swiftcoders.ca</strong> </p>
    
    `;

let privacyPolicy = `<p>Last updated: March 28, 2024</p>
<p>This Privacy Policy describes our policies and procedures on the collection, use and disclosure of your information when you use the Service and tells you about your privacy rights and how the law protects You.</p>
<p>We use Your personal data to provide and improve the service. By using the service, you agree to the collection and use of information in accordance with this privacy policy.</p>
<h2>Interpretation and Definitions</h2>
<h3>Interpretation</h3>
<p>The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.</p>
<h3>Definitions</h3>
<p>For the purposes of this Privacy Policy:</p>
<ul>
<li>
<p><strong>Account</strong> means a unique account created for You to access our Service or parts of our Service.</p>
</li>
<li>
<p><strong>Affiliate</strong> means an entity that controls, is controlled by or is under common control with a party, where &quot;control&quot; means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.</p>
</li>
<li>
<p><strong>Company</strong> (referred to as either &quot;the Company&quot;, &quot;We&quot;, &quot;Us&quot; or &quot;Our&quot; in this Agreement) refers to Swift Coders, 760 Galt Street, Apt 106.</p>
</li>
<li>
<p><strong>Cookies</strong> are small files that are placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses.</p>
</li>
<li>
<p><strong>Country</strong> refers to: Quebec,  Canada</p>
</li>
<li>
<p><strong>Device</strong> means any device that can access the Service such as a computer, a cellphone or a digital tablet.</p>
</li>
<li>
<p><strong>Personal Data</strong> is any information that relates to an identified or identifiable individual.</p>
</li>
<li>
<p><strong>Service</strong> refers to the Website.</p>
</li>
<li>
<p><strong>Service Provider</strong> means any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company, to perform services related to the Service or to assist the Company in analyzing how the Service is used.</p>
</li>
<li>
<p><strong>Usage Data</strong> refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).</p>
</li>
<li>
<p><strong>Website</strong> refers to Rules Of Pickleball, accessible from <a href="https://pbrulebook.com/" rel="external nofollow noopener" target="_blank">https://pbrulebook.com/</a></p>
</li>
<li>
<p><strong>You</strong> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.</p>
</li>
</ul>
<h2>Collecting and Using Your Personal Data</h2>
<h3>Types of Data Collected</h3>
<h4>Personal Data</h4>
<p>While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:</p>
<ul>
<li>
<p>Email address</p>
</li>
<li>
<p>First name and last name</p>
</li>
<li>
<p>Phone number</p>
</li>
<li>
<p>Address, State, Province, ZIP/Postal code, City</p>
</li>
<li>
<p>Usage Data</p>
</li>
</ul>
<h4>Usage Data</h4>
<p>Usage Data is collected automatically when using the Service.</p>
<p>Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages, unique device identifiers and other diagnostic data.</p>
<p>When You access the Service by or through a mobile device, We may collect certain information automatically, including, but not limited to, the type of mobile device You use, Your mobile device unique ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile Internet browser You use, unique device identifiers and other diagnostic data.</p>
<p>We may also collect information that Your browser sends whenever You visit our Service or when You access the Service by or through a mobile device.</p>
<h4>Tracking Technologies and Cookies</h4>
<p>We use Cookies and similar tracking technologies to track the activity on Our Service and store certain information. Tracking technologies used are beacons, tags, and scripts to collect and track information and to improve and analyze Our Service. The technologies We use may include:</p>
<ul>
<li><strong>Cookies or Browser Cookies.</strong> A cookie is a small file placed on Your Device. You can instruct Your browser to refuse all Cookies or to indicate when a Cookie is being sent. However, if You do not accept Cookies, You may not be able to use some parts of our Service. Unless you have adjusted Your browser setting so that it will refuse Cookies, our Service may use Cookies.</li>
<li><strong>Web Beacons.</strong> Certain sections of our Service and our emails may contain small electronic files known as web beacons (also referred to as clear gifs, pixel tags, and single-pixel gifs) that permit the Company, for example, to count users who have visited those pages or opened an email and for other related website statistics (for example, recording the popularity of a certain section and verifying system and server integrity).</li>
</ul>
<p>Cookies can be &quot;Persistent&quot; or &quot;Session&quot; Cookies. Persistent Cookies remain on Your personal computer or mobile device when You go offline, while Session Cookies are deleted as soon as You close Your web browser. Learn more about cookies on the <a href="https://www.privacypolicies.com/blog/privacy-policy-template/#Use_Of_Cookies_Log_Files_And_Tracking" target="_blank">Privacy Policies website</a> article.</p>
<p>We use both Session and Persistent Cookies for the purposes set out below:</p>
<ul>
<li>
<p><strong>Necessary / Essential Cookies</strong></p>
<p>Type: Session Cookies</p>
<p>Administered by: Us</p>
<p>Purpose: These Cookies are essential to provide You with services available through the Website and to enable You to use some of its features. They help to authenticate users and prevent fraudulent use of user accounts. Without these Cookies, the services that You have asked for cannot be provided, and We only use these Cookies to provide You with those services.</p>
</li>
<li>
<p><strong>Cookies Policy / Notice Acceptance Cookies</strong></p>
<p>Type: Persistent Cookies</p>
<p>Administered by: Us</p>
<p>Purpose: These Cookies identify if users have accepted the use of cookies on the Website.</p>
</li>
<li>
<p><strong>Functionality Cookies</strong></p>
<p>Type: Persistent Cookies</p>
<p>Administered by: Us</p>
<p>Purpose: These Cookies allow us to remember choices You make when You use the Website, such as remembering your login details or language preference. The purpose of these Cookies is to provide You with a more personal experience and to avoid You having to re-enter your preferences every time You use the Website.</p>
</li>
</ul>
<p>For more information about the cookies we use and your choices regarding cookies, please visit our Cookies Policy or the Cookies section of our Privacy Policy.</p>
<h3>Use of Your Personal Data</h3>
<p>The Company may use Personal Data for the following purposes:</p>
<ul>
<li>
<p><strong>To provide and maintain our Service</strong>, including to monitor the usage of our Service.</p>
</li>
<li>
<p><strong>To manage Your Account:</strong> to manage Your registration as a user of the Service. The Personal Data You provide can give You access to different functionalities of the Service that are available to You as a registered user.</p>
</li>
<li>
<p><strong>For the performance of a contract:</strong> the development, compliance and undertaking of the purchase contract for the products, items or services You have purchased or of any other contract with Us through the Service.</p>
</li>
<li>
<p><strong>To contact You:</strong> To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication, such as a mobile application's push notifications regarding updates or informative communications related to the functionalities, products or contracted services, including the security updates, when necessary or reasonable for their implementation.</p>
</li>
<li>
<p><strong>To provide You</strong> with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless You have opted not to receive such information.</p>
</li>
<li>
<p><strong>To manage Your requests:</strong> To attend and manage Your requests to Us.</p>
</li>
<li>
<p><strong>For business transfers:</strong> We may use Your information to evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Our assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which Personal Data held by Us about our Service users is among the assets transferred.</p>
</li>
<li>
<p><strong>For other purposes</strong>: We may use Your information for other purposes, such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and improve our Service, products, services, marketing and your experience.</p>
</li>
</ul>
<p>We may share Your personal information in the following situations:</p>
<ul>
<li><strong>With Service Providers:</strong> We may share Your personal information with Service Providers to monitor and analyze the use of our Service,  to contact You.</li>
<li><strong>For business transfers:</strong> We may share or transfer Your personal information in connection with, or during negotiations of, any merger, sale of Company assets, financing, or acquisition of all or a portion of Our business to another company.</li>
<li><strong>With Affiliates:</strong> We may share Your information with Our affiliates, in which case we will require those affiliates to honor this Privacy Policy. Affiliates include Our parent company and any other subsidiaries, joint venture partners or other companies that We control or that are under common control with Us.</li>
<li><strong>With business partners:</strong> We may share Your information with Our business partners to offer You certain products, services or promotions.</li>
<li><strong>With other users:</strong> when You share personal information or otherwise interact in the public areas with other users, such information may be viewed by all users and may be publicly distributed outside.</li>
<li><strong>With Your consent</strong>: We may disclose Your personal information for any other purpose with Your consent.</li>
</ul>
<h3>Retention of Your Personal Data</h3>
<p>The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.</p>
<p>The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of Our Service, or We are legally obligated to retain this data for longer time periods.</p>
<h3>Transfer of Your Personal Data</h3>
<p>Your information, including Personal Data, is processed at the Company's operating offices and in any other places where the parties involved in the processing are located. It means that this information may be transferred to — and maintained on — computers located outside of Your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from Your jurisdiction.</p>
<p>Your consent to this Privacy Policy followed by Your submission of such information represents Your agreement to that transfer.</p>
<p>The Company will take all steps reasonably necessary to ensure that Your data is treated securely and in accordance with this Privacy Policy and no transfer of Your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of Your data and other personal information.</p>
<h3>Delete Your Personal Data</h3>
<p>You have the right to delete or request that We assist in deleting the Personal Data that We have collected about You.</p>
<p>Our Service may give You the ability to delete certain information about You from within the Service.</p>
<p>You may update, amend, or delete Your information at any time by signing in to Your Account, if you have one, and visiting the account settings section that allows you to manage Your personal information. You may also contact Us to request access to, correct, or delete any personal information that You have provided to Us.</p>
<p>Please note, however, that We may need to retain certain information when we have a legal obligation or lawful basis to do so.</p>
<h3>Disclosure of Your Personal Data</h3>
<h4>Business Transactions</h4>
<p>If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We will provide notice before Your Personal Data is transferred and becomes subject to a different Privacy Policy.</p>
<h4>Law enforcement</h4>
<p>Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).</p>
<h4>Other legal requirements</h4>
<p>The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:</p>
<ul>
<li>Comply with a legal obligation</li>
<li>Protect and defend the rights or property of the Company</li>
<li>Prevent or investigate possible wrongdoing in connection with the Service</li>
<li>Protect the personal safety of Users of the Service or the public</li>
<li>Protect against legal liability</li>
</ul>
<h3>Security of Your Personal Data</h3>
<p>The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While We strive to use commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute security.</p>
<h2>Children's Privacy</h2>
<p>Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13. If You are a parent or guardian and You are aware that Your child has provided Us with Personal Data, please contact Us. If We become aware that We have collected Personal Data from anyone under the age of 13 without verification of parental consent, We take steps to remove that information from Our servers.</p>
<p>If We need to rely on consent as a legal basis for processing Your information and Your country requires consent from a parent, We may require Your parent's consent before We collect and use that information.</p>
<h2>Links to Other Websites</h2>
<p>Our Service may contain links to other websites that are not operated by Us. If You click on a third party link, You will be directed to that third party's site. We strongly advise You to review the Privacy Policy of every site You visit.</p>
<p>We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.</p>
<h2>Changes to this Privacy Policy</h2>
<p>We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page.</p>
<p>We will let You know via email and/or a prominent notice on Our Service, prior to the change becoming effective and update the &quot;Last updated&quot; date at the top of this Privacy Policy.</p>
<p>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</p>
<h2>Contact Us</h2>
<p>If you have any questions about this Privacy Policy, You can contact us:</p>
<ul>
<li>By email: <strong>support@swiftcoders.ca</strong></li>
</ul>`;

// Ignore specific warnings by adding the warning strings to the array
LogBox.ignoreLogs(['VirtualizedLists should never be nested']);
//Ignore 'Animated' warnings 
LogBox.ignoreLogs(['Animated: `useNativeDriver` is not supported because the native animated module is missing.']);

const openURL = async (url) => {
  if (await Linking.canOpenURL(url)) {
    await Linking.openURL(url);
  } else {
    console.log("Cannot open URL");
  }
};

const CustomHeaderTitle = ({ navigation }) => {
  return (
    <View style={styles.headerContainer}>
      <TouchableOpacity style={styles.menuButton} onPress={() => navigation.openDrawer()}>
        <Text style={Platform.OS === 'web' ? styles.menuCharWeb : styles.menuChar}>≡  </Text>
        
        {/* <Image style={styles.menuIcon} source={require('./assets/menu_icon.png')} /> */}
      </TouchableOpacity>
      <View style={styles.titleContainer}>
        {/* <Text style={styles.headerTitle}>IPF</Text> */}
        <Text style={styles.headerSubTitle}>Rules Of Pickleball</Text>
      </View>
      <View style={styles.logoContainer}>
        <Image style={styles.logo} source={require('./assets/ipf_logo.png')} />
      </View>
      {/* <Text style={styles.headerSubtitle} numberOfLines={1}>Rulebook App</Text> */}
    </View>
  );
};

const CustomDrawerContent = (props) => {
  const [isTermsVisible, setTermsVisible] = useState(false);
  const [isPrivacyVisible, setPrivacyVisible] = useState(false);

  return (
    <DrawerContentScrollView {...props} style={styles.drawerContainer} contentContainerStyle={styles.contentContainer}>
      <View style={styles.drawerHeader}>
        <Image style={styles.drawerLogo} source={require('./assets/ipf_logo.png')} />
        <Text style={styles.drawerTitle}>International Pickleball Federation</Text>
      </View>
      <DrawerItemList {...props} />
      <View style={styles.drawerFooter}>
        {/* GoFundMe fontAwesome icon link */}
        <Text style={styles.socialMediaText}>Donate</Text>
        <View style={styles.socialMediaIcons}>
          <TouchableOpacity onPress={() => openURL('https://gofund.me/968f74f3')}>
            <FontAwesome5 name="hand-holding-heart" style={styles.socialMediaIcon} />
          </TouchableOpacity>
        </View>
        <View style={styles.drawerLine2} />
        <Text style={styles.socialMediaText}>Follow us on</Text>
        <View style={styles.socialMediaIcons}>
          <TouchableOpacity onPress={() => openURL('https://www.facebook.com/theipfed')}>
            <FontAwesome5 name="facebook" style={styles.socialMediaIcon} />
          </TouchableOpacity>
          <TouchableOpacity onPress={() => openURL('https://www.instagram.com/theipforg/')}>
            <FontAwesome5 name="instagram" style={styles.socialMediaIcon} />
          </TouchableOpacity>
          <TouchableOpacity onPress={() => openURL('https://twitter.com/theipforg')}>
            <FontAwesome5 name="twitter" style={styles.socialMediaIcon} />
          </TouchableOpacity>
          <TouchableOpacity onPress={() => openURL('https://theipf.org/')}>
            <FontAwesome5 name="globe" style={styles.socialMediaIcon} />
          </TouchableOpacity>
          <TouchableOpacity onPress={() => openURL('https://www.linkedin.com/company/international-pickleball-federation')}>
            <FontAwesome5 name="linkedin" style={styles.socialMediaIcon} />
          </TouchableOpacity>
        </View>
        <View style={styles.drawerLine3} />
        <View style={styles.developedBySection} >
          <Text style={styles.versionText}>Version 1.0</Text>
          <View style={styles.source} >
            <Text style={styles.drawerFooterText}>Developped by SwiftCoders</Text>
          </View>
          <Image style={styles.swiftCodeLogo} source={require('./assets/swiftcode-logo3.png')} />
        </View>
        <View style={styles.drawerLine3} />
        <View style={styles.termsAndPrivacyPolicy} >
          <TouchableOpacity onPress={() => setTermsVisible(true)}>
            <Text style={styles.termsAndPrivacyPolicyStyle}>Terms of Service</Text>
          </TouchableOpacity>
          <TouchableOpacity onPress={() => setPrivacyVisible(true)}>
            <Text style={styles.termsAndPrivacyPolicyStyle}>Privacy Policy</Text>
          </TouchableOpacity>
        </View>
      </View>
      <Modal
          animationType="slide"
          // transparent={true}
          visible={isTermsVisible}
          borderColor={'#653463'}
          borderWidth={3}
          overflow={'hidden'}
          onRequestClose={() => { setTermsVisible(false); }}>
              <View 
                  style={{
                      flex: 1,
                      justifyContent: 'center',
                      alignItems: 'center',
                      backgroundColor: '#683267',
                  }}
              >
                  <View style={styles.termsModal}>
                      <Text>Terms of Service</Text>
                      <ScrollView>
                          {/* <Text>{termsOfService}</Text> */}
                          <HTML source={{ html: termsOfService }} />
                      </ScrollView>
                      <TouchableOpacity title="Close" onPress={() => setTermsVisible(false)} style={styles.button}>
                          <Text style={styles.buttonText}>Close</Text>
                      </TouchableOpacity>
                  </View>
              </View>
      </Modal>
      <Modal
          animationType="slide"
          // transparent={true}
          visible={isPrivacyVisible}
          borderColor={'#653463'}
          borderWidth={3}
          overflow={'hidden'}
          onRequestClose={() => { setPrivacyVisible(false); }}>
              <View 
                  style={{
                      flex: 1,
                      justifyContent: 'center',
                      alignItems: 'center',
                      backgroundColor: '#683267',
                  }}
              >
                  <View style={styles.termsModal}>
                      <Text>Privacy Policy</Text>
                      <ScrollView>
                          {/* <Text>{privacyPolicy}</Text> */}
                          <HTML source={{ html: privacyPolicy }} />
                      </ScrollView>
                      <TouchableOpacity title="Close" onPress={() => setPrivacyVisible(false)} style={styles.button}>
                          <Text style={styles.buttonText}>Close</Text>
                      </TouchableOpacity>
                  </View>
              </View>
      </Modal>


    </DrawerContentScrollView>
  );
};

const HomeStack = () => (
  <Stack.Navigator screenOptions={{ headerShown: true }} >
    <Stack.Screen 
      name="Rules Of Pickleball" 
      component={HomeScreen}
      options={({ navigation }) => ({ 
        header: () => <CustomHeaderTitle navigation={navigation} />
      })} 
    />
    <Stack.Screen
      name="RuleDetailsScreen" 
      component={RuleDetailsScreen}
    />
    <Stack.Screen 
      name="Profile" 
      component={ProfileScreen} 
    />
  </Stack.Navigator>
);

const ProfileStack = () => (
    <Stack.Navigator screenOptions={{ headerShown: true }} >
      <Stack.Screen
        name="ProfileStack"
        component={ProfileScreen}
        options={({ navigation }) => ({
          header: () => <CustomHeaderTitle navigation={navigation} />
        })}
      />
    </Stack.Navigator>
);



export default function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <NavigationContainer>
          <MyDrawer />
        </NavigationContainer>
      </PersistGate>
    </Provider>
  );
}

function MyDrawer() {
  const isAuthenticated = useSelector((state) => state.user?.isAuthenticated);

  return (
    <Drawer.Navigator
      initialRouteName="HomeStack"
      styles={styles.container}
      screenOptions={{
        headerShown: false,
        swipeEdgeWidth: 0,
        drawerStyle: { backgroundColor: '#ffebae', width: 240 },
        drawerItemStyle: { backgroundColor: '#653463', borderRadius: 10, marginHorizontal: 15, height: 45 },
        drawerLabelStyle: { fontSize: 14, fontWeight: "bold", color: '#ffebae', justifyContent: 'center', alignSelf: 'center', paddingStart: 30 },
      }}
      drawerContent={(props) => <CustomDrawerContent {...props} />}
    >
      <Drawer.Screen
        name="Home"
        component={HomeStack}
        styles={styles.drawerOption}
      />
      {isAuthenticated ? (
        <Drawer.Screen
          name="Profile"
          component={ProfileStack}
          listeners={({ navigation }) => ({
            tabPress: (e) => {
              e.preventDefault();
              navigation.navigate('ProfileStack');
            },
          })}
        />
      ) : null}
    </Drawer.Navigator>
  );
}
// Register the app component
AppRegistry.registerComponent('App', () => App);  //registering the app

// Define navigationOptions for the App component (Note: navigationOptions are not used in the current code)
App.navigationOptions = {   //setting the title of the app
  title: 'IPF Pickleball Rules App',
};

const styles = StyleSheet.create({
  container: {
    // flex: 1,
    // alignItems: 'center',
    // justifyContent: 'center',
    // paddingBottom: 0,
    // marginBottom: 0,
    paddingTop: 50,
    // backgroundColor: '#ffebae',
  },
  contentContainer: {
    width: '100%',
    // backgroundColor: 'white',
  },
  drawerContainer: {
    backgroundColor: '#ffebae',
  },
  title: {
    color: '#fff',
    fontSize: 30,
    fontWeight: 'bold',
  },
  headerContainer: {
    // backgroundColor: 'orange',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: Platform.OS === 'web' ? 0 : 50, // Adjust padding for web
    backgroundColor: '#ffebae',
    borderBottomWidth: 0.5,
    borderBottomColor: 'lightgrey',
  },
  menuButton: {
    flexDirection: 'row',
  },
  menuChar: {
    fontSize: 32,
    color: '#653463',
    paddingStart: 16,
  },
  menuCharWeb: {
    fontSize: 34,
    color: '#653463',
    paddingStart: 22,
  },
  titleContainer: {
    alignContent: 'center',
  },
  headerTitle: {
    fontSize: 34,
    fontWeight: 'bold',
    color: '#653463',
    paddingTop: 0,
    textAlign: 'center',
  },
  headerSubTitle: {
    fontSize: 26,
    color: '#653463',
    paddingTop: 0,
    textAlign: 'center',
  },
  logoContainer: {
    paddingVertical: 5,
    paddingHorizontal: 5,
  },
  logo: {
    width: 80,
    height: 80,
  },
  drawerHeader: {
    // backgroundColor: 'orange',
    alignItems: 'center',
    justifyContent: 'center',
    // paddingTop: Platform.OS === 'web' ? 0 : 20, // Adjust padding for web
    backgroundColor: '#ffebae',
    paddingBottom: 15,
  },
  drawerOption: {
    
  },
  drawerLogo: {
    width: 100,
    height: 100,
    alignSelf: 'center',
    marginTop: 10,
    marginBottom: 5,
  },
  drawerTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#653463',
    paddingHorizontal: 5,
    textAlign: 'center',
  },
  drawerLine: {
    borderBottomColor: '#653463',
    borderBottomWidth: 0.5,
    marginHorizontal: 30,
    marginTop: 10,
    marginBottom: 10,
  },
  drawerLine2: {
    borderBottomColor: '#653463',
    borderBottomWidth: 0.5,
    marginBottom: 10,
  },
  drawerLine3: {
    borderBottomColor: '#653463',
    borderBottomWidth: 0.5,
    marginBottom: 15,
  },

  //Align to bottom
  developedBySection: {
    alignItems: 'center',
  },
  socialMediaIcons: {
    flexDirection: 'row',
    alignSelf: 'center',
    paddingBottom: 20,
  },
  socialMediaText: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#653463',
    paddingBottom: 15,
    textAlign: 'center',
  },
  socialMediaIcon: {
    fontSize: 24,
    color: '#653463',
    paddingHorizontal: 8,
  },
  drawerFooter: {
    backgroundColor: '#ffebae',
    alignSelf: 'center',
    // stick to bottom
    position: Platform.OS === 'ios' ? 'absolute' : null,
    top: Platform.OS === 'ios' ? "120%" : null,
    paddingTop: 20,
  },
  drawerFooterText: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#653463',
    paddingHorizontal: 5, 
  },
  contractorName: {
    fontSize: 12,
    fontWeight: 'bold',
    fontStyle: 'italic',
    color: '#653463',
    paddingHorizontal: 5, 
    paddingVertical: 5,
  },
  versionText: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#653463',
    paddingHorizontal: 5, 
    paddingBottom: 5,
  },
  source: {
  },
  swiftCodeLogo: {
    width: 80,
    height: 80,
    marginBottom: 5,
    marginTop: 5,
  },
  termsAndPrivacyPolicy: {
    alignItems: 'center',
    paddingBottom: 10,
  },
  termsAndPrivacyPolicyStyle: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#653463',
    paddingHorizontal: 5, 
    paddingVertical: 5,
  },
  termsOfServiceText: {
    fontSize: 14,
    width: '80%',
  },
  termsModal: {
      width: '40%',
      // height: '90%',
      minWidth: 340,
      minHeight: 450,
      maxHeight: 630,
      backgroundColor: '#fffaeb',
      borderRadius: 20,
      overflow: 'hidden',
      padding: 20,
  },
  buttonText: {
      fontSize: 18,
      color: 'white',
  },
  button: {
      backgroundColor: '#653463',
      padding: 10,
      borderRadius: 10,
      marginTop: 20,
      alignItems: 'center',
  },


});
